module.exports = __webpack_public_path__ + "img/hero-desktop.4067b595.webp";